import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2bf0e212"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ncgr-card ncgr-card--rounded-to-normal" }
const _hoisted_2 = { class: "ncgr-container ncgr-pad-t-24 ncgr-pad-b-24" }
const _hoisted_3 = { class: "product__image" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "product__info" }
const _hoisted_6 = { class: "product__spec" }
const _hoisted_7 = { class: "product__price" }
const _hoisted_8 = { class: "ncgr-align-right ncgr-typography-bold ncgr-mar-t-8" }
const _hoisted_9 = {
  class: "ncgr-mar-t-16",
  "data-test": "shipping-date"
}
const _hoisted_10 = {
  key: 0,
  class: "ncgr-typography-success expected-date ncgr-mar-t-16 ncgr-mar-b-8"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { class: "ncgr-typography-medium ncgr-typography-bold ncgr-typography-success" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "ncgr-typography-small ncgr-typography-secondary-label" }, [
  /*#__PURE__*/_createElementVNode("li", null, " ※ 受注製作のため発送予定日が前後する場合があります。 "),
  /*#__PURE__*/_createElementVNode("li", null, " ※ ご注文後のキャンセル、変更はお受けできません。ご了承の上、ご注文ください。 ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lineItems, (lineItem, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "product ncgr-pad-b-16"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              class: "ncgr-image",
              src: lineItem.thumbnailUrl
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", null, " カラー：" + _toDisplayString(_ctx.formatItemColor(lineItem.variant)), 1),
              _createElementVNode("p", null, " サイズ：" + _toDisplayString(_ctx.$t(`item-size.${lineItem.sizeName}`)), 1),
              _createElementVNode("p", null, " 数量：" + _toDisplayString(lineItem.quantity), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.formatPrice(lineItem.priceWithTax)), 1)
            ])
          ])
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_9, [
        (!_ctx.campaign.sample)
          ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
              _createTextVNode(" 発送予定日 "),
              _hoisted_11,
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.formatDate(_ctx.campaign.scheduledShippingDate)) + "ごろ ", 1)
            ]))
          : _createCommentVNode("", true),
        _hoisted_13
      ])
    ])
  ]))
}